import React, { useState, useMemo, memo, ReactNode } from 'react';
import { AlertMessage, AlertContext } from './context';

interface AlertsProviderProps {
  children: ReactNode;
}

const AlertProvider = ({ children }: AlertsProviderProps): JSX.Element => {
  const [alertMessage, setAlertMessage] = useState<AlertMessage | undefined>(undefined);
  const [alertsVisible, setAlertsVisible] = useState<boolean>(false);

  const contextValue = useMemo(
    () => ({
      alertMessage,
      setAlertMessage,
      alertsVisible,
      setAlertsVisible,
    }),

    [alertMessage, alertsVisible]
  );
  return <AlertContext.Provider value={contextValue}>{children}</AlertContext.Provider>;
};

export default AlertProvider;
